<div class="rating" title="{{getStarLabel()}}" [attr.data-ta-rating]="rating">
  <span [ngClass]="getStarClass(1)"></span>
  <span [ngClass]="getStarClass(2)"></span>
  <span [ngClass]="getStarClass(3)"></span>
  <span [ngClass]="getStarClass(4)"></span>
  <span [ngClass]="getStarClass(5)"></span>
</div>
